module.exports = __webpack_public_path__ + "static/ticket_checker_help5-820afb83b6e04320eb21c7eef7e5cfab.jpg";